/**
 * @remarks for handling 3 times vacancy error
 */
import { PortalAdapterApi } from "@vacancorp/portal.adapter.api";
import Vue from "vue";
import { mapState, mapMutations } from "vuex";
import portal from "@vacancorp/portal";

type DataType = {
  vacancyError3Times: boolean; // 同じ店舗の時に
  vacancyErrorAlertShown: boolean; // 連続３回 vacancy errorある場合, alert popup
  vacancyErrorAlertCounts: number;
};

export default Vue.extend({
  name: "mixin-map-view-vacancy-error",
  data(): DataType {
    return {
      vacancyError3Times: false,
      vacancyErrorAlertShown: false,
      vacancyErrorAlertCounts: 0,
    };
  },
  computed: {
    ...mapState("data", ["selectedGenre"]),
  },
  methods: {
    ...mapMutations("data", ["setGenreList"]),
    ...mapMutations("ui", [
      "setVacancyErrorAlertShown",
      "setVacancyErrorBannerShown",
    ]),
    hasVacancyError(
      vacancyList: PortalAdapterApi.ResponseGetMergedDisplayVacancy[],
      sortedPlaceList: portal.PublicPlaceWithVacancyId[]
    ): boolean {
      const hasUnknownStatus = vacancyList.some(
        (vacancy) => vacancy.status === "unknown"
      );
      // vacancyList.length !== sortedPlaceList.length; is not enough
      // a placeIdHash is not in vacancyList
      let placeIdHashNotMatched = false;
      for (let place of sortedPlaceList) {
        const matched:
          | PortalAdapterApi.ResponseGetMergedDisplayVacancy
          | undefined = vacancyList.find(
          (vacancy) => vacancy.placeIdHash === place.placeIdHash
        );
        if (matched) continue;
        else {
          placeIdHashNotMatched = true;
          break;
        }
      }
      return (
        hasUnknownStatus ||
        vacancyList.length !== sortedPlaceList.length ||
        placeIdHashNotMatched
      );
    },
    vacancyErrorAlertClicked() {
      this.setVacancyErrorAlertShown(false);
      this.zeroVacancyErrorAlertCounts();
    },
    addVacancyErrorAlertCounts() {
      this.vacancyErrorAlertCounts += 1;
      console.log(
        `addVacancyErrorAlertCounts: ${this.vacancyErrorAlertCounts}`
      );
    },
    zeroVacancyErrorAlertCounts() {
      this.vacancyErrorAlertCounts = 0;
    },
    setVacancyErrorAlertShown(payload: boolean) {
      // https://vacan.slack.com/archives/CHGFXM7UZ/p1626845814447800?thread_ts=1626422981.418000&cid=CHGFXM7UZ
      // only 避難所, 投票所 popup the fullscreen alert
      if (
        payload &&
        this.selectedGenre !== "evacuation-center" &&
        this.selectedGenre !== "polling-place"
      ) {
        return;
      }
      this.vacancyErrorAlertShown = payload;
    },
    setVacancyError3Times(payload: boolean) {
      this.vacancyError3Times = payload;
    },
    resetVacancyErrorCounting() {
      this.setVacancyError3Times(false);
      this.setVacancyErrorBannerShown(false);
      this.zeroVacancyErrorAlertCounts();
    },
  },
});
